import { IContractDisplaySection } from 'services/contract/types';
import { ContractSection } from './ContractSection';
import { DistributionSection } from './DistributionSection';

interface ContractSectionsRendererProps {
  sections: IContractDisplaySection[];
}

export const ContractSectionsRenderer = ({ sections }: ContractSectionsRendererProps) => {
  return (
    <div className="flex w-full flex-col">
      {sections.map((section, idx) =>
        section.type === 'distribution' ? (
          <DistributionSection
            key={`distribution-${section.title}-${idx}`}
            title={section.title}
            section={section.data}
          />
        ) : (
          <ContractSection key={`custom-${section.title}-${idx}`} section={section.data} />
        ),
      )}
    </div>
  );
};
